import { helper } from '@ember/component/helper';

import { htmlSafe } from '@ember/template';

const noopString = 'javascript:void(0)';
const noop = htmlSafe(noopString);

export default helper(function noUrlHelper([ url ]) {
  url = url && `${url}`.trim();
  return !url || url === noopString ? noop : url;
});
